import { OTHER_PERMISSIONS_CATEGORY } from './labelConstants';

/** Categoría visible de un permiso; sin categoría, «Otros permisos». */
export function permissionCategoryLabel(category: string | undefined): string {
    return category?.trim() || OTHER_PERMISSIONS_CATEGORY;
}
